import * as React from 'react';

import { utils, HardcodedToDoExplainer } from 'kb-shared';

import InsuranceCardUploadButton from '../../PhotoUpload/InsuranceCard/InsuranceCardUploadButton';
import ButtonTodo from './ButtonTodo';

const { setInsuranceCardWasSkipped } = utils;

interface Props {
  explainer: HardcodedToDoExplainer;
}

const UploadInsuranceCard = (props: Props) => {
  const {
    explainer: { title, body }
  } = props;
  return (
    <ButtonTodo
      title={title}
      copy={body}
      onDismiss={() => {
        setInsuranceCardWasSkipped(true);
      }}
      ButtonComponent={<InsuranceCardUploadButton />}
    />
  );
};

export default UploadInsuranceCard;
